import { useMemo, useState } from 'react';
import { cn } from '@/lib/utils';

interface ExpandableTextProps {
  text: string;
  className?: string;
  collapsedLines?: number;
  minCharactersToToggle?: number;
  buttonClassName?: string;
}

export const ExpandableText = ({
  text,
  className,
  collapsedLines = 4,
  minCharactersToToggle = 220,
  buttonClassName,
}: ExpandableTextProps) => {
  const [expanded, setExpanded] = useState(false);

  const shouldToggle = useMemo(
    () => text.length > minCharactersToToggle || text.includes('\n'),
    [minCharactersToToggle, text],
  );

  return (
    <div>
      <div
        className={cn('whitespace-pre-wrap', className)}
        style={expanded || !shouldToggle
          ? undefined
          : {
            display: '-webkit-box',
            WebkitLineClamp: collapsedLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
      >
        {text}
      </div>

      {shouldToggle && (
        <button
          type="button"
          onClick={() => setExpanded((current) => !current)}
          className={cn(
            'mt-2 text-xs font-medium text-domino-prune transition-colors hover:text-domino-aubergine',
            buttonClassName,
          )}
        >
          {expanded ? 'Voir moins' : 'Voir plus'}
        </button>
      )}
    </div>
  );
};
